import React from 'react';
import {
    TemplateTitleContainer,
    TemplateTitle,
    BackTitle,
} from './SetDetails.styled';
import LeftArrow from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';

export default function SetItemDetailTitle({
    isCondensedView,
    previousCfn,
    showBackText,
    onBackClick,
    handleClose,
    backText,
    t,
    isMobileView,
    sizes,
    isSetDetail,
}) {
    const isWide = window.innerWidth > sizes.mobileDevice;

    const handleBack = () => {
        if (previousCfn) {
            onBackClick(previousCfn);
        } else {
            handleClose(false);
        }
    };

    const getBackText = () => {
        if (previousCfn) {
            const dynamicId = `setItemDetails-backto-${
                previousCfn?.bom || previousCfn?.cfn
            }`;
            return (
                <span id={dynamicId}>
                    {`${t(
                        isSetDetail
                            ? 'equity.cart.setDetails.backto'
                            : 'common.backToText'
                    )} ${previousCfn?.bom || previousCfn?.cfn}`}
                </span>
            );
        }
        return backText;
    };

    // Desktop back title
    const renderBackTitle = () => {
        if (!isCondensedView || !isWide) return null;
        if (previousCfn || showBackText) {
            return (
                <BackTitle
                    width="80%"
                    onClick={handleBack}
                    marginLeft="-3px"
                >
                    <img src={LeftArrow} alt="back" />
                    {getBackText()}
                </BackTitle>
            );
        }
        return null;
    };

    // Mobile back title
    const renderMobileBackTitle = () => {
        if (window.innerWidth > sizes.mobileDevice) return null;
        if (previousCfn || showBackText) {
            return (
                <BackTitle
                    width="80%"
                    margin={
                        showBackText
                            ? isCondensedView
                                ? '10px 0 10px 7px'
                                : '10px 0 10px 15px'
                            : undefined
                    }
                    onClick={handleBack}
                >
                    <img src={LeftArrow} alt="back" />
                    {getBackText()}
                </BackTitle>
            );
        }
        return null;
    };

    return (
        <>
            <TemplateTitleContainer
                isCondensedView={isCondensedView}
            >
                {renderBackTitle()}
            
                <TemplateTitle
                mbPaddingLeft={'0px'}
                    style={{
                        width: '100%',
                        textAlign:
                            isCondensedView && isWide ? 'left' : 'center',
                        marginRight: isCondensedView
                            ? isMobileView
                                ? 'center'
                                : '0px'
                            : 'none',
                    }}
                >
                    {isSetDetail
                        ? t('equity.cart.setDetails.setDetails')
                        : t('common.itemDetailsText')}
                </TemplateTitle>
                {/* <Icon
                    id="set-item-detail-close-icon"
                    data-testid="close-icon"
                    mobilePath={Close}
                    onClick={() => handleClose(false)}
                /> */}
            </TemplateTitleContainer>
            {renderMobileBackTitle()}
        </>
    );
}
